export default function emails(field) {
	if (field === "service") {
		return "service_evfg5de";
	} else if (field === "template") {
		return "template_cbkr75d";
	} else if (field === "public") {
		return "VmIE3TlDYfBUJfHyH";
	}
}
